import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const RiskDisclaimer = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenDisclaimer = localStorage.getItem('hasSeenRiskDisclaimer');
    if (!hasSeenDisclaimer) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('hasSeenRiskDisclaimer', 'true');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-96 overflow-y-auto">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center space-x-3">
              <AlertTriangle className="h-6 w-6 text-danger-600 flex-shrink-0" />
              <h2 className="text-xl font-bold text-gray-900">
                Important Risk Disclosure
              </h2>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="space-y-4 text-sm text-gray-700">
            <p className="font-medium text-danger-700">
              Day trading involves substantial risk of loss and is not suitable for all investors.
            </p>

            <div className="space-y-3">
              <div>
                <h3 className="font-medium text-gray-900 mb-1">Key Risks:</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>You may lose all or more than your initial investment</li>
                  <li>Past performance does not guarantee future results</li>
                  <li>Market volatility can result in rapid and substantial losses</li>
                  <li>Leverage amplifies both gains and losses</li>
                  <li>Technical analysis and algorithms are not infallible</li>
                </ul>
              </div>

              <div>
                <h3 className="font-medium text-gray-900 mb-1">Important Disclaimers:</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>This application provides analysis tools, not financial advice</li>
                  <li>All recommendations are for informational purposes only</li>
                  <li>You should conduct your own research before making investment decisions</li>
                  <li>Consider your risk tolerance and financial situation</li>
                  <li>Consult with a qualified financial advisor if needed</li>
                </ul>
              </div>

              <div>
                <h3 className="font-medium text-gray-900 mb-1">Regulatory Notice:</h3>
                <p>
                  Day trading is subject to significant regulatory requirements. Ensure you understand 
                  pattern day trading rules, margin requirements, and tax implications before trading.
                </p>
              </div>
            </div>

            <div className="bg-warning-50 border border-warning-200 rounded-lg p-4">
              <p className="text-warning-800 font-medium">
                Only trade with money you can afford to lose. Never invest borrowed money or funds 
                needed for essential expenses.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <button
              onClick={handleAccept}
              className="btn-primary flex-1"
            >
              I Understand the Risks
            </button>
            <button
              onClick={handleClose}
              className="btn-secondary flex-1"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskDisclaimer;